<script setup lang="ts">
import {
  ComboboxContent,
  useForwardPropsEmits,
  type ComboboxContentProps,
  type ComboboxContentEmits
} from 'reka-ui'
import { cn } from '@/lib/utils'
import type { ClassValue } from 'clsx'

interface Props extends ComboboxContentProps {
  class?: ClassValue
}

const props = defineProps<Props>()
const emits = defineEmits<ComboboxContentEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <ComboboxContent
    v-bind="forwarded"
    :class="cn('max-h-[300px] overflow-x-hidden overflow-y-auto', $attrs.class ?? '')"
  >
    <div role="presentation">
      <slot />
    </div>
  </ComboboxContent>
</template>
